import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from 'utils'

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': SessionManager.getCookie('user_token'),
})

export const recipeList = createAsyncThunk('recipe/list', async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'recipe',
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                recipe_status: data?.recipe_status,
            },
            headers: headers(),
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const recipeDetails = createAsyncThunk('recipe/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `recipe/${id}`,
            headers: headers(),
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const approveRecipe = createAsyncThunk('recipe/approve', async ({ id }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'approved_recipe',
            data: {
                recipe_id: id,
                recipe_status: 'Approved',
            },
            headers: headers(),
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const rejectRecipe = createAsyncThunk('recipe/reject', async ({ id }) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'approved_recipe',
            data: {
                recipe_id: id,
                recipe_status: 'Rejected',
            },
            headers: headers(),
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const delRecipe = createAsyncThunk('recipe/delete', async (data) => {
    try {
        const res = await axios({
            method: 'DELETE',
            url: getConfig.API_URL + `recipe/${data?.id}`,
            headers: headers(),
        })
        return res
    } catch (error) {
        return error.response
    }
})

const handleAuthError = (action) => {
    if (action?.payload?.status === 401) {
        showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg?.navigate)
    } else if (action?.payload?.status === 403) {
        showAccessDeniedAlert(action.meta.arg?.navigate)
    }
}

const recipe = createSlice({
    name: 'recipe',
    initialState: {
        list: [],
        details: null,
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(recipeList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })

        builder.addCase(recipeDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        })
    },
})

export default recipe.reducer;